const initialState = {
  // Stock report
  isGettingStockReport: false,
  stockReport: [],
  page: 0,
  totalResults: 0,
  lowStockThreshold: 5,
  stockReportError: "",

  // Per-item movement history
  isGettingStockMovements: false,
  stockMovements: [],
  movementsTotalResults: 0,
  movementsItem: null,
  // What the item held either side of the window the rows were read for. With
  // no window, the closing figure is simply the current stock.
  movementsOpeningBalance: 0,
  movementsClosingBalance: 0,
  stockMovementsError: "",

  // Printing the ledger
  isExportingStockLedger: false,

  // Manual adjustment
  isAdjustingStock: false,
};

const StockReducer = (state = initialState, action) => {
  switch (action.type) {
    // Stock report
    case "STOCK_REPORT_REQUEST":
      return { ...state, isGettingStockReport: true, stockReportError: "" };
    case "STOCK_REPORT_SUCCESS":
      return {
        ...state,
        stockReport: action.payload?.data || [],
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        lowStockThreshold:
          action.payload?.lowStockThreshold ?? state.lowStockThreshold,
        isGettingStockReport: false,
      };
    case "STOCK_REPORT_ERROR":
      return {
        ...state,
        isGettingStockReport: false,
        stockReport: [],
        stockReportError: action.payload,
      };

    // Movement history
    case "STOCK_MOVEMENTS_REQUEST":
      return {
        ...state,
        isGettingStockMovements: true,
        stockMovementsError: "",
      };
    case "STOCK_MOVEMENTS_SUCCESS":
      return {
        ...state,
        stockMovements: action.payload?.data || [],
        movementsTotalResults: action.payload?.totalResults || 0,
        movementsItem: action.payload?.item || null,
        movementsOpeningBalance: action.payload?.openingBalance ?? 0,
        movementsClosingBalance: action.payload?.closingBalance ?? 0,
        isGettingStockMovements: false,
      };
    case "STOCK_MOVEMENTS_ERROR":
      return {
        ...state,
        isGettingStockMovements: false,
        stockMovements: [],
        stockMovementsError: action.payload,
      };
    case "STOCK_MOVEMENTS_CLEAR":
      return {
        ...state,
        stockMovements: [],
        movementsItem: null,
        movementsTotalResults: 0,
        movementsOpeningBalance: 0,
        movementsClosingBalance: 0,
        stockMovementsError: "",
      };

    // Printing the ledger
    case "EXPORT_STOCK_LEDGER_REQUEST":
      return { ...state, isExportingStockLedger: true };
    case "EXPORT_STOCK_LEDGER_DONE":
      return { ...state, isExportingStockLedger: false };

    // Manual adjustment
    case "ADJUST_STOCK_REQUEST":
      return { ...state, isAdjustingStock: true };
    case "ADJUST_STOCK_SUCCESS":
      return { ...state, isAdjustingStock: false };
    case "ADJUST_STOCK_ERROR":
      return { ...state, isAdjustingStock: false };

    default:
      return state;
  }
};

export default StockReducer;
